export default "__VITE_ASSET__D7w6Q8ZH__"